/* eslint-disable no-dupe-else-if */
import { useEffect, useState, useRef, useContext } from "react"
import intl from "react-intl-universal"
import FileIcon from "../../../../../assets/icons/CIQIcon"
import ContentBlank from "../../../../molecules/ContentBlank"
import styles from "./index.module.scss"
import RcmpCheckBox from "../../../../atoms/Checkbox"
import RcmpHeader from "../../../../atoms/Header"
import { TableLinkAnalytes } from "../../components/TableLinkAnalytes"
import { listAnalytesCreated } from "../../../../../services/ciq"
import RcmpLoading from "../../../../atoms/Loading"
import InfiniteScroll from "../../../../atoms/InfiniteScroll"
import "./style.css"
import Input from "../../../../atoms/Input"
import { FormAddControl } from "../../components/FormAddControl"
import { ModalVinculateAnalytes } from "../../components/ModalVinculateAnalytes"
import { debounce } from "../../../../../utils/debounce"
import { AnalytePicker } from "../../components/AnalytePicker"
import { ModalSettingsControl } from "../../components/ModalSettingsControl"
import { ControlsContext } from "../../../../../contexts/Controls"
import { useNavigate } from "react-router-dom"
import { fnCanAtLeast } from "../../../../../utils/permissions"

const AddControls = () => {
  const navigate = useNavigate()
  const [bIsOpenModalAnalytePicker, setBisOpenModalAnalytePicker] = useState(false)
  const [listAnalytes, setListAnalytes] = useState([])
  const [listAnalytesHistory, setListAnalytesHistory] = useState([])
  const [cSearchText, setSearchText] = useState("")
  const [isChecked, setIsChecked] = useState(false)
  const [isLoad, setIsLoad] = useState(false)
  const [listAnalytesAddInEqp, setListAnalytesAddInEqp] = useState([])
  const [infoInfititeScroll, setInfoInfititeScroll] = useState({})
  const [nPage, setNPage] = useState(1)
  const [abreadCrumbs, setAbreadCrumbs] = useState([])
  const [tableBodyArray, setTableBodyArray] = useState([])
  const [eqp_analytes, setEqpAnalytes] = useState([])
  const [cLevel, setCLevel] = useState("")
  const [bIsOpenModalSettingsEquiment, setbIsOpenModalSettingsEquiment] = useState(false)
  const [isShowToolTip, setIsShowToolTip] = useState(false)

  const [analytesVinculatedWithEquipment, setAnalytesVinculatedWithEquipment] = useState(
    [],
  )
  const [isCheckedSwitch, setIsCheckedSwitch] = useState(false)

  const { dataConfigAnalyte, setDataConfigAnalyte } = useContext(ControlsContext)

  const [isSwitchSuspense, setIsSwitchSuspense] = useState(
    dataConfigAnalyte.anlt_bstatus === true ||
      dataConfigAnalyte.anlt_bstatus === "Ativo" ||
      dataConfigAnalyte.anlt_bstatus === "Active",
  )

  const fnListAnalytes = async (npage, cSearchText, cLevel) => {
    if (isLoad) return
    try {
      setIsLoad(true)
      if (npage <= 1) setListAnalytes([])

      const queryPams = cLevel
        ? `&custom_filters[context]=control&custom_filters[value]=${cLevel}&anlt_bstatus=1`
        : "&anlt_bstatus=1"

      const response = await listAnalytesCreated(npage, cSearchText, queryPams)

      const newData = response.data.data.data
        .map((item) => {
          return {
            anlt_cname: item.anlt_cname,
            anlt_type: item.anlt_type,
            anlt_ruler: "---",
            anlt_imprecision: "---",
            anlt_sector: item.anlt_sector?.sector_cname,
            anlt_nid: item.anlt_nid,
            anlt_result_options:
              item.anlt_result_options.length > 0
                ? item.anlt_result_options.map((item) => ({
                    ...item,
                    cntrlanltrops_ecompliance: "C",
                  }))
                : item.anlt_result_options,
            anlt_bstatus: item.anlt_bstatus
              ? intl.get("ciq.list_analytes.active")
              : intl.get("ciq.list_analytes.inactive"),
            bChecked: false,
          }
        })
        .map((item) => {
          if (item.anlt_type === "Quantitativo") {
            return { ...item, anlt_type: intl.get("ciq.types_analytes.quantitative") }
          } else if (item.anlt_type === "Qualitativo") {
            return { ...item, anlt_type: intl.get("ciq.types_analytes.qualitative") }
          } else {
            return {
              ...item,
              anlt_type: intl.get("ciq.types_analytes.semmi_quantitative"),
            }
          }
        })

      setInfoInfititeScroll({
        last_page: response.data.data.last_page,
      })

      const mergedList = newData.map((item) => {
        const markedItem = listAnalytesHistory.find(
          (mark) => mark.anlt_nid === item.anlt_nid,
        )
        return markedItem ? { ...item, bChecked: markedItem.bChecked } : item
      })

      setListAnalytes((prev) => [...prev, ...mergedList])
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoad(false)
    }
  }

  const fnSearchAnalyte = debounce((ev) => {
    const value = ev.target.value.toLowerCase()

    setSearchText(!value ? "" : `&search_text=${value}`)
  }, 500)

  const fnHandleChange = () => {
    const everyPropertiesIsChecked = listAnalytes.every((item) => item.bChecked === true)
    if (!everyPropertiesIsChecked) {
      const newList = listAnalytes.map((item) => {
        return {
          ...item,
          bChecked: true,
        }
      })
      setIsChecked(true)
      setListAnalytes(newList)

      const resultado = listAnalytesHistory.slice()
      newList.forEach((item) => {
        const existeItem = resultado.some((elem) => elem.anlt_cname === item.anlt_cname)
        if (!existeItem) {
          resultado.push(item)
        }
      })

      setListAnalytesHistory(resultado)
    } else {
      setListAnalytes((oldState) =>
        oldState.map((item) => ({ ...item, bChecked: false })),
      )
      setIsChecked(false)

      var listaFiltrada = listAnalytesHistory.filter(function (item1) {
        return !listAnalytes.some(function (item2) {
          return (
            item1.anlt_cname === item2.anlt_cname &&
            item1.anlt_sector === item2.anlt_sector &&
            item1.anlt_type === item2.anlt_type &&
            item1.anlt_bstatus === item2.anlt_bstatus &&
            item1.anlt_nid === item2.anlt_nid &&
            item1.bChecked === item2.bChecked
          )
        })
      })

      setListAnalytesHistory(listaFiltrada)
    }
  }

  const fnHandleSelectAnalyte = (item) => {
    const obj = {
      ...item,
      bChecked: !item.bChecked,
    }

    const newList = listAnalytes.map((it) => {
      if (it.anlt_nid === item.anlt_nid) {
        return obj
      } else {
        return it
      }
    })

    setListAnalytesHistory((oldState) => [...oldState, obj])

    setListAnalytes(newList)

    if (listAnalytesHistory.length === 0) {
      return
    } else if (listAnalytesHistory.some((item) => item.anlt_nid === obj.anlt_nid)) {
      setListAnalytesHistory(
        listAnalytesHistory.filter((item) => item.anlt_nid !== obj.anlt_nid),
      )
    }
  }

  function fnNextPage(page) {
    setNPage(page)
  }

  useEffect(() => {
    setNPage(1)
    fnListAnalytes(1, cSearchText, cLevel)
  }, [cSearchText, cLevel])

  useEffect(() => {
    if (nPage <= 1) return
    fnListAnalytes(nPage, cSearchText, cLevel)
  }, [nPage])

  const everyPropertiesIsChecked = listAnalytes.every((item) => item.bChecked === true)

  useEffect(() => {
    if (everyPropertiesIsChecked) {
      setIsChecked(true)
    } else {
      setIsChecked(false)
    }
  }, [listAnalytes])

  useEffect(() => {
    if (!bIsOpenModalAnalytePicker) {
      const newList = listAnalytes.map((item) => {
        return {
          ...item,
          bChecked: false,
        }
      })

      setListAnalytes(newList)
      setListAnalytesHistory([])
    }
  }, [bIsOpenModalAnalytePicker])

  function removeElementsDuplicated(lista1, lista2) {
    return lista2.filter(function (item2) {
      return (
        lista1.findIndex(function (item1) {
          return item1.anlt_nid === item2.anlt_nid
        }) === -1
      )
    })
  }

  // Aplicar a função e obter a nova list
  const listRemovedDuplicated = removeElementsDuplicated(
    analytesVinculatedWithEquipment,
    listAnalytes,
  )

  useEffect(() => {
    setAbreadCrumbs([
      {
        path: "./",
        name: intl.get("home"),
      },
      {
        path: "/ciq",
        name: intl.get("ciq.title"),
      },
      {
        path: "/ciq/list-controls",
        name: intl.get("ciq.controls"),
      },
      {
        name: intl.get("ciq.edit_control"),
        bActive: true,
      },
    ])
  }, [listAnalytesAddInEqp, analytesVinculatedWithEquipment])

  useEffect(() => {
    const bAdmin = fnCanAtLeast("admin", "internal-quality-control")

    if (bAdmin || fnCanAtLeast("create-edit-control", "internal-quality-control")) {
      return
    } else if (!fnCanAtLeast("access-ciq", "internal-quality-control")) {
      window.location.href = "/"
      return
    } else if (
      fnCanAtLeast("create-edit-equipment", "internal-quality-control") ||
      fnCanAtLeast("create-edit-launch", "internal-quality-control") ||
      fnCanAtLeast("update-run", "internal-quality-control")
    ) {
      window.location.href = "/"
      return
    }
  }, [])

  const removeDuplicated = removeElementsDuplicated(
    listAnalytesAddInEqp,
    listRemovedDuplicated,
  )

  useEffect(() => {
    const data = analytesVinculatedWithEquipment
      .concat(listAnalytesAddInEqp)
      .map((item, index) => ({
        ...item,
        eqpanlt_norder: index,
        anlt_bstatus:
          item.anlt_bstatus === true ||
          item.anlt_bstatus === "Ativo" ||
          item.anlt_bstatus === "Active"
            ? intl.get("ciq.list_analytes.active")
            : intl.get("ciq.list_analytes.inactive"),
      }))

    setTableBodyArray(data)

    setEqpAnalytes(
      listAnalytesAddInEqp.map((item) => {
        return {
          eqpanlt_anlt_nid: item.anlt_nid,
          eqpanlt_bstatus:
            item.anlt_bstatus === true ||
            item.anlt_bstatus === "Ativo" ||
            item.anlt_bstatus === "Active"
              ? intl.get("ciq.list_analytes.active")
              : intl.get("ciq.list_analytes.inactive"),
        }
      }),
    )
  }, [listAnalytesAddInEqp])

  return (
    <div>
      <RcmpHeader
        elIcon={<FileIcon />}
        cTitlePage={intl.get("ciq.internal_control_quality")}
        aBreadCrumbs={abreadCrumbs}
        className={styles.header}
      ></RcmpHeader>
      <ContentBlank
        bShowFilter={false}
        bCanSearch={false}
        bVisibleIconSearch={false}
        bArrowLeftGoBack={true}
        cPathGoBack={"/ciq/list-controls"}
        cLabelGoBack={intl.get("ciq.add_control", { plural: "" })}
        className={styles.contentB1lankCustom}
      >
        <FormAddControl
          cLevel={cLevel}
          setCLevel={setCLevel}
          setBisOpenModal={setBisOpenModalAnalytePicker}
          equipment_analytes={tableBodyArray.map((item) => ({
            eqpanlt_anlt_nid: item.anlt_nid,
            eqpanlt_bstatus: item.anlt_bstatus,
            eqpanlt_nimprecision_value: item.eqpanlt_nimprecision_value,
            eqpanlt_cjustification: item.eqpanlt_cjustification,
            eqpanlt_norder: item.eqpanlt_norder,
            eqpanlt_naverage: item.eqpanlt_naverage || 0,
            eqpanlt_nstandard_deviation: item.eqpanlt_nstandard_deviation || 0,
            eqpanlt_result_options:
              item.anlt_result_options.length === 2
                ? [
                    {
                      cntrlanltrops_resultopt_nid:
                        item.anlt_result_options[0].resultopt_nid,
                      cntrlanltrops_ecompliance: "C",
                    },
                    {
                      cntrlanltrops_resultopt_nid:
                        item.anlt_result_options[1].resultopt_nid,
                      cntrlanltrops_ecompliance: "N",
                    },
                  ]
                : item.anlt_result_options.map((item) => ({
                    cntrlanltrops_resultopt_nid: item.resultopt_nid,
                    cntrlanltrops_ecompliance: "C",
                  })) || [],
          }))}
          analytesVinculatedWithEquipment={analytesVinculatedWithEquipment}
        >
          <TableLinkAnalytes
            bControl
            thead={[
              intl.get("ciq.header_table_link_analytes.name"),
              intl.get("ciq.header_table_link_analytes.type"),
              intl.get("ciq.info_exam_analyte"),
              intl.get("ciq.header_table_link_analytes.status"),
              "",
            ]}
            tbodyArray={tableBodyArray}
            setTableBodyArray={setTableBodyArray}
            eqp_analytes={eqp_analytes}
            setEqpAnalytes={setEqpAnalytes}
            cursorNormal
            cTextNoData={intl.get("ciq.any_analyte_link")}
            handleClickRemoveAnalyteLinked={(e) => {
              setListAnalytesAddInEqp(
                tableBodyArray
                  .map((item) => ({
                    anlt_cname: item.anlt_cname,
                    anlt_type: item.anlt_type,
                    anlt_info: item.anlt_info,
                    anlt_bstatus: item.anlt_bstatus,
                    anlt_nid: item.anlt_nid,
                    anlt_result_options: item.anlt_result_options,
                    bChecked: item.bChecked,
                  }))
                  .filter((item) => item.anlt_nid !== e.anlt_nid),
              )
            }}
            handleClickSettings={(e) => {
              // setTimeout(() => {
              //   setbIsOpenModalSettingsEquiment(true)
              // }, 100)
              // setDataConfigAnalyte(e)
              // setIsSwitchSuspense(
              //   e.anlt_bstatus === true ||
              //     e.anlt_bstatus === "Ativo" ||
              //     e.anlt_bstatus === "Active",
              // )
            }}
          />
        </FormAddControl>
      </ContentBlank>

      {bIsOpenModalAnalytePicker && (
        <AnalytePicker
          bControl
          listAnalytesHistory={listAnalytesHistory}
          setBisOpenModal={setBisOpenModalAnalytePicker}
          setListAnalytesAddInEqp={setListAnalytesAddInEqp}
          listAnalytesAddInEqp={tableBodyArray.map((item) => ({
            anlt_cname: item.anlt_cname,
            anlt_type: item.anlt_type,
            anlt_info: item.anlt_info,
            anlt_bstatus: item.anlt_bstatus,
            anlt_nid: item.anlt_nid,
            anlt_result_options: item.anlt_result_options,
            bChecked: item.bChecked,
          }))}
          infoInfititeScroll={infoInfititeScroll}
          fnNextPage={fnNextPage}
          isChecked={isChecked}
          fnHandleChange={fnHandleChange}
          fnSearchAnalyte={fnSearchAnalyte}
          removeDuplicated={removeDuplicated}
          everyPropertiesIsChecked={everyPropertiesIsChecked}
          fnHandleSelectAnalyte={fnHandleSelectAnalyte}
          isLoad={isLoad}
          nPage={nPage}
        />
      )}

      {bIsOpenModalSettingsEquiment && (
        <ModalSettingsControl
          tableBodyArray={tableBodyArray}
          setTableBodyArray={setTableBodyArray}
          setbIsOpenModalSettingsEquiment={setbIsOpenModalSettingsEquiment}
          isTabEdit={true}
          setIsTabEdit={() => {}}
          isSwitchSuspense={isSwitchSuspense}
          setIsSwitchSuspense={setIsSwitchSuspense}
          setIsCheckedSwitch={setIsCheckedSwitch}
        />
      )}
    </div>
  )
}
export default AddControls
